module.exports = __webpack_public_path__ + "static/media/snow_fall.90e4aab4.gif";